// extracted by mini-css-extract-plugin
module.exports = {"body":"ImageShowStable_body__29uMm","empty":"ImageShowStable_empty__1Pw_N"};